import styled from 'styled-components';
import {COLORS, Typography} from '@fupa/fupa-uikit';

const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0.75rem 0.625rem 0.75rem;
  background-color: ${props => props.color};
  margin: 0.5rem 0;
  color: ${COLORS.white};
`;

const NotificationButtonContainer = styled.div`
  display: flex;
  justify-content: ${props => props.justify};
  margin-top: 0.375rem;
`;

const HintText = styled(Typography)`
  &&& {
    color: ${COLORS.white};
  }
`;


export {NotificationContainer, NotificationButtonContainer, HintText}
